<script setup lang="ts">
import * as commonConstants from '@/constants/common';
</script>

<template>
  <div
    :class="$style.dispatchSectionWrapper"
    data-testid="dispatchSectionWrapper"
  >
    <div :class="$style.headerWrapper">
      <div :class="$style.widthHeader">
        <slot name="header">{{ commonConstants.EM_DASH }}</slot>
      </div>
    </div>
    <div :class="$style.main">
      <slot>{{ commonConstants.EM_DASH }}</slot>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dispatchSectionWrapper {
  border: 1px solid colors.$color-gray-200;
  background-color: colors.$color-white;
}
  .headerWrapper {
    background-color: colors.$color-gray-200;
    padding: 0 16px;
    min-height: 40px;
    display: flex;
    align-items: center;
  }
    .widthHeader {
      width: 100%;
    }
  .main {
    padding: 0 16px;
  }
</style>
